import { useMutation, useQueryClient } from 'react-query';
import { opportunitiesOrchestratorAxiosApi } from 'src/Config/axiosApi';

/**
 * Re-expose previously hidden pairs to the opener. Inverse of
 * `useHidePairFromOpener` — `PATCH /pairs/:id/show-in-opener` on the
 * pair-manager. There is no bulk endpoint, so multi-row "show" loops the
 * single-pair PATCH sequentially; a mid-loop failure surfaces normally
 * while the already-shown pairs stay shown (re-running is idempotent).
 */
export async function showPairsInOpener(pairIds: string[]): Promise<number> {
  let shown = 0;
  for (const pairId of pairIds) {
    await opportunitiesOrchestratorAxiosApi.patch(`/pairs/${pairId}/show-in-opener`);
    shown += 1;
  }
  return shown;
}

export function useShowInOpener() {
  const qc = useQueryClient();
  return useMutation((pairIds: string[]) => showPairsInOpener(pairIds), {
    mutationKey: 'entry:show-in-opener',
    onSuccess: () => {
      // Prefix-invalidates both the 'active' and 'hidden' pair lists.
      qc.invalidateQueries('manual-confirmed-pairs');
    }
  });
}
